module.exports = __webpack_public_path__ + "img/icon_bRem.0c0b456a.svg";